/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
 */

// App Requires
require('./vendor/iframeResizer.min');
require('./vendor/jquery.fitvids.js');
require('./app/config');
require('./app/global');
require('./app/modal');